module.exports = __webpack_public_path__ + "img/biometric-id.ea82c647.svg";